import React from 'react';
import { suggestions, suggestionsIntl } from './suggestions';
import { getIntl } from '../../../../../../../utils/intl';
import { View } from 'react-native';
import Stack from '../../../../../../v2BaseComponents/Stack';
import Text from '../../../../../../v2BaseComponents/Text';
import Suggestion from './Suggestion';
import { getSpacing } from '../../../../../../../utils/spacing';
import { PRScrollView } from '../../../../../../shared/Scroll';

const intl = getIntl('emptyChatState', {
    sendMessage: 'Ask a question to get started...',
    examples: 'Some examples of what you can ask:',
});

type EmptyChatStateProps = {
    onSuggestionPress: (suggestion: string) => void;
};

const EmptyChatState: React.FC<EmptyChatStateProps> = ({ onSuggestionPress }) => {
    // Randomly choose 3 suggestions to display
    const randomSuggestions = React.useMemo(() => {
        const shuffled = suggestions.sort(() => 0.5 - Math.random());
        return shuffled.slice(0, 3);
    }, []);

    return (
        <PRScrollView contentContainerStyle={{ flexGrow: 1, alignSelf: 'stretch' }}>
            <View
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'flex-start',
                }}
                testID="empty-chat-state"
            >
                <Stack
                    space={getSpacing(10)}
                    vertical
                    style={{
                        marginTop: getSpacing(20),
                        width: '100%',
                    }}
                >
                    <Text
                        variant="h2"
                        color="Inactive-Text"
                        alignText="center"
                        style={{
                            fontWeight: '400',
                            fontFamily: 'OverpassRegular',
                            alignSelf: 'center',
                        }}
                    >
                        {intl('sendMessage')}
                    </Text>
                    <Stack
                        space={getSpacing(4)}
                        vertical
                        style={{
                            width: '100%',
                            alignItems: 'center',
                        }}
                    >
                        <Text variant="h4" alignText="center">
                            {intl('examples')}
                        </Text>
                        <Stack
                            space={getSpacing(2)}
                            vertical
                            style={{
                                display: 'flex',
                                width: '90%',
                                alignItems: 'center',
                            }}
                        >
                            {randomSuggestions.map((suggestion) => (
                                <Suggestion
                                    key={suggestion}
                                    text={suggestionsIntl(suggestion)}
                                    onPress={() => {
                                        onSuggestionPress(suggestionsIntl(suggestion));
                                    }}
                                />
                            ))}
                        </Stack>
                    </Stack>
                </Stack>
            </View>
        </PRScrollView>
    );
};

export default React.memo(EmptyChatState);
